/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_CountryInputs */

const en_orders_country = /** @type {(inputs: Orders_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country`)
};

const es_orders_country = /** @type {(inputs: Orders_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pais`)
};

/**
* | output |
* | --- |
* | "Country" |
*
* @param {Orders_CountryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_country = /** @type {((inputs?: Orders_CountryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_CountryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_country(inputs)
	return es_orders_country(inputs)
});